export default __webpack_public_path__ + "static/media/oscer-pres-knee-pain.15371c26.svg";